import _ from 'lodash';
import TransferManager from './transfer-manager';
import EventService from './event-service';

const AsperaService = {
	_currentStatus: '',
	_runningListeners: [],
	_isListening: false,

	_onStatusChanged(eventType, data) {
		if( AsperaService._currentStatus === data ) {
			return;
		}

		let wasAsperaRunning = AsperaService._currentStatus === 'RUNNING';
		let isAsperaRunning = data === 'RUNNING';

		if( wasAsperaRunning || isAsperaRunning ) {
			AsperaService._notifyRunningListeners(isAsperaRunning);
		}

		AsperaService._currentStatus = data;
	},

	_notifyRunningListeners(isRunning) {
		for( let listener of AsperaService._runningListeners ) {
			listener(isRunning);
		}
	},

	get isRunning() {
		return TransferManager.pluginStatus() === 'RUNNING';
	},

	addRunningListener(listener) {
		if( !AsperaService._isListening ) {
			// The session may already be running before anything watches it — the
			// downloads page or another dropzone can have primed it — and that
			// first broadcast is long gone. Seed the status from the live one, or
			// the next transition away from RUNNING reads as non-running to
			// non-running and listeners never hear that Connect went down.
			AsperaService._currentStatus = TransferManager.pluginStatus();

			EventService.on('Connect:Plugin:Status', AsperaService._onStatusChanged);
			AsperaService._isListening = true;
		}

		AsperaService._runningListeners.push(listener);
	},

	removeRunningListener(listener) {
		AsperaService._runningListeners = _.without(AsperaService._runningListeners, listener);
	},

	setCredentials(session, token) {
		TransferManager.setCredentials(session, token);
	}
};

export default AsperaService;
